/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import CollectionModule from 'client/store/modules/CollectionModule';
import IdentityProvidersApi from 'client/api/v2/IdentityProvidersApi';

export class IdentityProvidersCollectionClass extends CollectionModule {
  extractModule() {
    const module = super.extractModule();
    return module;
  }

  // --------------------------------------------------------------------------
  // State
  // --------------------------------------------------------------------------
  getInitialState() {
    const state = super.getInitialState();
    return state;
  }

  // --------------------------------------------------------------------------
  // Actions
  // --------------------------------------------------------------------------
}

export function createIdentityProvidersCollectionClass() {
  return new IdentityProvidersCollectionClass(IdentityProvidersApi, 'objectId').extractModule();
}
